module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"active":"Active"}}')
  delete Component.options._Ctor
}
